<!-- @format -->
<template>
    <v-btn
        :class="[
            'gst-btn gst-btn-category-filter',
            $vuetify.breakpoint.lgAndUp && 'gst-btn-category-filter-hover',
        ]"
        depressed
        v-bind="$attrs"
        @click="$emit('click')">
        {{ text }}
    </v-btn>
</template>
<script>
export default {
    name: 'CategoryFilterButton',
    inheritAttrs: true,
    props: {
        text: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-btn.v-btn.gst-btn-category-filter {
    height: 49px !important;
    padding: theme-spacing(4) theme-spacing(6);
    margin: 0 theme-spacing(2);
    color: theme-color('white');
    font-size: font-size('l');
    text-transform: capitalize;
    border-color: theme-color('white') !important;
    opacity: 1 !important;
    border-radius: 50px !important;
    border-width: 1px !important;

    &.v-item--active {
        background-color: theme-color('new-secondary') !important;
        color: theme-color('black');
        border-color: theme-color('new-secondary') !important;
    }
}

.gst-btn.v-btn.gst-btn-category-filter-hover:hover {
    background-color: theme-color('primary') !important;
    color: theme-color('white');
    border-color: theme-color('primary') !important;
}
</style>
